import React from 'react';
import DataBlock from '../DataBlock';

const Equivalencies = (props) => (
    <div className="ghg-grid-row ghg-results-list">
        {props.requirements.map((output, index, array) => {
            const useOr = index !== (array.length - 1) ? <div className="ghg-or-separator">or</div> : '';
            return (
                <div key={index}>
                    <DataBlock
                        icon={output.icon}
                        description={output.description}
                        info={output.info}
                        outputValue={output.value} />
                    {useOr}
                </div>
            );
        })}
    </div>
);

export default Equivalencies


/** WEBPACK FOOTER **
 ** ./src/components/Requirements/Requirements.js
 **/